import {Pipe, PipeTransform} from '@angular/core';
import {PriceDisplayService} from '../services/core/price-display.service';

/**
 * Label of a price with the tax rate: "netto" when the price is shown net (corporate customer), otherwise ''.
 * Usage: <span *ngIf="Product.Tax | NetLabel">netto</span>. Not pure: changes with the login.
 */
@Pipe({
  name: 'NetLabel',
  pure: false
})
export class NetLabelPipe implements PipeTransform {
  constructor(private priceDisplayService: PriceDisplayService) {
  }

  transform(tax: number): string {
    return this.priceDisplayService.net && tax != null ? 'netto' : '';
  }
}
